<div [ngStyle]="contentStyle" class="section pointer-events-none">
  <form
    class="beneficiary-form finxForm"
    [ngStyle]="parentFormWidgetRowGap ? { gap: parentFormWidgetRowGap } : {}"
    [formGroup]="addressForm"
    (ngSubmit)="onSubmit()"
    *ngIf="addressForm"
  >
    <div class="text-left">
      <div>
        <finxone-input
          [type]="'text'"
          [name]="'addressLine1'"
          [label]="dataIn?.attri?.widgetProperties?.addressLine1 ?? 'Address line 1'"
          formControlName="addressLine1"
          [value]="addressForm?.get('addressLine1')?.value ?? ''"
        >
        </finxone-input>
      </div>
    </div>
    <ng-container *ngIf="true">
      <div class="text-left" *ngIf="enableAddress2">
        <div>
          <finxone-input
            [type]="'text'"
            [name]="'addressLine2'"
            [label]="dataIn?.attri?.widgetProperties?.addressLine2 ?? 'Address line 2'"
            formControlName="addressLine2"
            [value]="addressForm?.get('addressLine2')?.value ?? ''"
          >
          </finxone-input>
        </div>
      </div>
      <div class="text-left" *ngIf="enableAddress3">
        <div>
          <finxone-input
            [type]="'text'"
            [name]="'addressLine3'"
            [label]="dataIn?.attri?.widgetProperties?.addressLine3 ?? 'Address line 3'"
            formControlName="addressLine3"
            [value]="addressForm?.get('addressLine3')?.value ?? ''"
          >
          </finxone-input>
        </div>
      </div>
      <div class="text-left" *ngIf="enableAddress4">
        <div>
          <finxone-input
            [type]="'text'"
            [name]="'addressLine4'"
            [label]="dataIn?.attri?.widgetProperties?.addressLine4 ?? 'Address line 4'"
            formControlName="addressLine4"
            [value]="addressForm?.get('addressLine4')?.value ?? ''"
          >
          </finxone-input>
        </div>
      </div>
    </ng-container>

    <div class="text-left">
      <div>
        <finxone-input
          type="text"
          [name]="'addressCity'"
          formControlName="addressCity"
          [label]="dataIn?.attri?.widgetProperties?.cityLabel"
          [value]="addressForm?.get('addressCity')?.value"
        ></finxone-input>
      </div>
    </div>
    <div class="text-left">
      <div>
        <ng-template #customOption let-countryList>
          <span class="d-inline-flex gap-2">
            <span class="d-contents" [innerHTML]="countryList.currencyFlag | safeHtml"></span>
            <span>{{ countryList.title }}</span>
          </span>
        </ng-template>
        <ng-template #customSelectedOption>
          <span class="d-inline-flex gap-2">
            <span
              class="d-contents"
              [innerHTML]="selectedCountryOption?.currencyFlag ?? '' | safeHtml"
            ></span>
            <span>{{ selectedCountryOption?.title }}</span>
          </span>
        </ng-template>
        <finxone-select-dropdown
          id="address-country"
          formControlName="addressCountry"
          [options]="countryList"
          [customOptionTemplate]="customOption"
          [customSelectedOptionTemplate]="customSelectedOption"
          [optionLabelKey]="'title'"
          [optionValueKey]="'key'"
          [appendToBody]="true"
          [searchEnabled]="true"
          [selectedOption]="selectedCountryOption?.title ?? ''"
          [label]="dataIn?.attri?.widgetProperties?.countryLabel"
          (selectionChange)="valueChangeCountry()"
        >
        </finxone-select-dropdown>
      </div>
    </div>

    <div class="text-left" *ngIf="addressForm?.get('addressState')">
      <div>
        @if (isShowStateDropdown) {
        <div class="country-dropdown">
          <finxone-select-dropdown
            id="address-state"
            formControlName="addressState"
            [options]="states"
            [optionLabelKey]="'name'"
            [optionValueKey]="'state_code'"
            [appendToBody]="true"
            [selectedOption]="selectedStateOption?.name ?? ''"
            [label]="dataIn?.attri?.widgetProperties?.stateRegionLabel"
          >
          </finxone-select-dropdown>
        </div>
        } @else {
        <finxone-input
          type="text"
          [name]="'addressState'"
          formControlName="addressState"
          [label]="dataIn?.attri?.widgetProperties?.stateRegionLabel"
          [value]="addressForm?.get('addressState')?.value"
        ></finxone-input>
        }
      </div>
    </div>

    <div class="text-left" *ngIf="addressForm?.get('addressPostCode')">
      <div>
        <finxone-input
          type="text"
          [name]="'addressPostCode'"
          formControlName="addressPostCode"
          [label]="dataIn?.attri?.widgetProperties?.zipPostalLabel"
          [value]="addressForm?.get('addressPostCode')?.value ?? ''"
        ></finxone-input>
      </div>
    </div>
    @if (showNestedButton) {
    <div class="mt-8" [ngStyle]="nestedButtonParentCss">
      <finx-button
        type="submit"
        [labeltext]="renderedContent"
        [disabled]="!addressForm?.valid"
        class="pointer-events-none d-flex"
        [class.h-100]="!isAllowedGlobalStyling"
        [buttonStyle]="!isAllowedGlobalStyling ? reviewDetailsButtonStyle : {}"
        [class]="isAllowedGlobalStyling ? globalStylingClass : 'w-100'"
        [class.mandatory-cta-button]="!isAllowedGlobalStyling"
        [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      ></finx-button>
    </div>
    }
  </form>
</div>
